//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has, isEqual } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListOneWayBingo = (data) => async (dispatch) => {
    try {
        const video = await apis.post('oneway_bingo', `/listBingo`, {
            body: data
        });
        if (Array.isArray(video)) {
            await dispatch(Actions.listOnewayBingo(video));
            return video;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing one way bingo',
                error,
                module: 'BINGO',
                operation: 'LIST_ORGANIZATION_WORD_BANK'
            });
        }
    }
};

export const handleListTeachers = (data) => async (dispatch) => {
    try {
        const video = await apis.post('oneway_bingo', `/listAllTeachers`, {
            body: data
        });
        if (Array.isArray(video)) {
            await dispatch(Actions.listTeachersBingo(video));
            return video;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing teachers nationwide bingo',
                error,
                module: 'BINGO',
                operation: 'LIST_TEACHER_NOTE_BOOK'
            });
        }
    }
};

export const handleCreateOneWayBingo = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('oneway_bingo', `/createBingo`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOnewayBingo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one way bingo',
                error,
                module: 'BINGO',
                operation: 'CREATE_ORGANIZATION_WORD_BANK'
            });
        }
    }
};

export const handleCreateOneWayBingoSession = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('oneway_bingo', `/createBingoSession`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOnewayBingo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one way bingo session',
                error,
                module: 'BINGO',
                operation: 'CREATE_ORGANIZATION_WORD_BANK_STUDENT'
            });
        }
    }
};

export const handleUpdateOneWayBingo = (data) => async (dispatch) => {
    try {
        const videos = await apis.put('oneway_bingo', `/updateBingo`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.updateOnewayBingo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating one way bingo',
                error,
                module: 'BINGO',
                operation: 'UPDATE_ORGANIZATION_WORD_BANK'
            });
        }
        console.log(error,"error")
    }
};

export const handleSyncBingo = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('oneway_bingo', `/create_bingo_assignment`, {
            body: data
        });
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing bingo',
                error,
                module: 'BINGO',
                operation: 'SET_BOOK'
            });
        }
        console.log(error,"error")
    }
};

export const handledeleteSyncBinfo = (id) => async (dispatch) => {
    try {
        const data = await apis.post('oneway_bingo', `/delete_bingo_assignment`, {
            body: {
                debate_id:id
            }
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting sync bingo',
                error,
                module: 'BINGO',
                operation: 'DELETE_STUDENT_BOOK'
            });
        }
        console.log(error,"error")
    }
};

export const handleDeleteOnewayBingo = (id) => async (dispatch) => {
    try {
        const videos = await apis.del('oneway_bingo', `/deleteBingo/${id}`);
        if (has(videos, "id")) {
            await dispatch(Actions.deleteOnewayBingo(id));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting one way bingo',
                error,
                module: 'BINGO',
                operation: 'DELETE_ORGANIZATION_WORD_BANK'
            });
        }
    }
};

// Worksheet
export const handleListWorksheet = (data) => async (dispatch) => {
    try {
        const listWorksheet = await apis.post('oneway_bingo', `/listWorksheet`, {
            body: data
        });
        if (Array.isArray(listWorksheet)) {
            // await dispatch(Actions.listOnewayBingo(listWorksheet));
            return listWorksheet;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'BINGO',
                operation: 'LIST_ONE_WAY_BINGO'
            })
        }
    }
};

export const handleCreateWorksheet = (data) => async (dispatch) => {
    try {
        const workSheetData = await apis.post('oneway_bingo', `/createWorksheet`, {
            body: data
        });
        // if (has(workSheetData, "id")) {
        //     await dispatch(Actions.createOnewayBingo(workSheetData));
        // }
        return workSheetData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'BINGO',
                operation: 'LIST_TEACHERS'
            })
        }
    }
};

export const handleLearningModuleCount = (data) => async (dispatch, getState) => {
    try {
        const getLearningModuleCount = await apis.post('oneway_bingo', `/get_learning_module_counts`, {
            body: data
        });
        if(getLearningModuleCount?.result) {
            const prevLearningModuleCount = getState()?.learningModuleCount;
            if(!isEqual(prevLearningModuleCount, getLearningModuleCount)) {
                await dispatch(Actions.getLearningModuleCount(getLearningModuleCount));
            }
        }
        return getLearningModuleCount;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in getting learning module count',
                error,
                module: 'BINGO',
                operation: 'LIST_ONE_WAY_BINGO'
            })
            // Sentry.captureException(error)
        }
    }
};